import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { isNil, Nillable } from '@web/utils';
import { BaseCollectionFilterRequestBuilder } from './base-collection-filter-request.builder';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';

export class TextCollectionFilterRequestBuilder<
  Filter,
> extends BaseCollectionFilterRequestBuilder<Filter> {
  public equal(): this {
    return this.operator(CollectionFilterOperator.Equal);
  }

  public caseIntensiveLike(): this {
    return this.operator(CollectionFilterOperator.CaseInsensitiveLike);
  }

  public like(): this {
    return this.operator(CollectionFilterOperator.Like);
  }

  public in(): this {
    return this.operator(CollectionFilterOperator.In);
  }

  public startsWith(): this {
    return this.operator(CollectionFilterOperator.StartsWith);
  }

  public equalFor(property: CollectionFilterKey<Filter>): this {
    return this.equal().property(property);
  }

  public caseIntensiveLikeFor(property: CollectionFilterKey<Filter>): this {
    return this.caseIntensiveLike().property(property);
  }

  public likeFor(property: CollectionFilterKey<Filter>): this {
    return this.like().property(property);
  }

  public inFor(property: CollectionFilterKey<Filter>): this {
    return this.in().property(property);
  }

  public startsWithFor(property: CollectionFilterKey<Filter>): this {
    return this.startsWith().property(property);
  }

  public override build(): Nillable<CollectionFilterRequest> {
    this.configureDefaultOperator();

    return super.build();
  }

  private configureDefaultOperator(): void {
    if (!isNil(this._operator)) {
      return;
    }

    this.caseIntensiveLike();
  }
}
